import { Container, Selectors } from "@jds/core";
import { useState } from "react";
import JioSnapStats from "../../components/Admin/JioSnapStats/JioSnapStats";
import EventStats from "../../components/Admin/EventStats/EventStats";
import JioSnapStatsGrid from "../../components/Admin/JioSnapStatsGrid/JioSnapStatsGrid";

const Admin = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = () => {
    setTabIndex((pre) => {
      if (pre === 0) {
        return 1;
      } else {
        return 0;
      }
    });
  };
  return (
    <div className="inner-container" style={{ paddingTop: 120 }}>
      <Container style={{ width: "540px" }}>
        <Selectors
          stretch
          selectedIndex={tabIndex}
          onChange={handleTabChange}
          items={[
            {
              label: "JioSnap Stats",
              value: "jiosnap",
            },
            {
              label: "Event Stats",
              value: "event",
            },
          ]}
        />
      </Container>
      {tabIndex === 0 ? <JioSnapStats /> : <EventStats />}
    </div>
  );
};

export default Admin;
